const REFERRAL_CODE_KEY = 'fb_referral_code';

export const sanitizeReferralCode = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  return trimmed.toUpperCase();
};

export const storeReferralCode = (value: unknown): void => {
  if (typeof window === 'undefined') return;
  const safe = sanitizeReferralCode(value);
  try {
    if (safe) {
      window.sessionStorage.setItem(REFERRAL_CODE_KEY, safe);
    } else {
      window.sessionStorage.removeItem(REFERRAL_CODE_KEY);
    }
  } catch {
    // Ignore storage failures to avoid blocking auth/profile flows.
  }
};

export const peekReferralCode = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    return sanitizeReferralCode(window.sessionStorage.getItem(REFERRAL_CODE_KEY));
  } catch {
    return null;
  }
};

export const clearReferralCode = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(REFERRAL_CODE_KEY);
  } catch {
    // Ignore storage failures.
  }
};
